import React, { useCallback } from 'react';

import { Actions, Action, SendIcon, EditIcon } from '@gogame/components';
import Permissions from '@gogame/permissions';

import { ACTION_EDIT, ACTION_SHARE_WITH_AF } from 'scenes/Events/constants';
import { useSendToAppsFlyer } from 'scenes/Events/data';

export default ({ actions, data, onEdit }) => {
  const sendToAppsFlyer = useSendToAppsFlyer();

  const handleSendToAppsFlyer = useCallback(() => {
    sendToAppsFlyer({
      appId: data.application?.id,
      eventName: data.name,
      reasonCode: data.reasonCode,
    });
  }, [data, sendToAppsFlyer]);

  const handleEdit = useCallback(() => {
    onEdit({ id: data.id });
  }, [data, onEdit]);

  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <Actions limit={2}>
          <Action
            id={'sendToAppsFlyer'}
            icon={<SendIcon />}
            label={'Send to AppsFlyer'}
            onClick={handleSendToAppsFlyer}
            disabled={!isActionAllowed(ACTION_SHARE_WITH_AF)}
          />
          <Action
            id={'edit'}
            icon={<EditIcon />}
            label={'Edit'}
            onClick={handleEdit}
            disabled={!isActionAllowed(ACTION_EDIT)}
          />
        </Actions>
      )}
    </Permissions>
  );
};
